import './styles.scss';

import { faBitcoinSign } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const BitcoinIcon = () => {
  return <FontAwesomeIcon icon={faBitcoinSign} className="bitcoin-icon" />;
};
